import axios from "axios";
import {
  BASE_URL,
  USER,
  DEPARTMENT,
  UNIT,
  CUSTOMER,
  DUTY_TYPE,
  ROLE,
  SHIFT,
  STATION,
  CUSTOMER_LIST,
  STATION_LIST,
  DEPARTMENT_LIST,
  UNIT_LIST,
  DUTY_TYPE_LIST,
  ROLE_LIST,
  SHIFT_LIST,
  LOGIN,
  LOGOUT,
  SUBACTIVITY_LIST,
  SUBACTIVITY,
  MICROACTIVITY_LIST,
  MICROACTIVITY,
  MICROACTIVITY_UNIQUE_LIST,
  PRODUCT,
  PRODUCT_LIST,
  REMARK,
  REMARK_LIST,
  PROJECT,
  PROJECT_LIST,
  CHANGE_PASSWORD,
  TECHNICIAN,
  TECHNICIAN_LIST,
  USER_LIST,
  FORGET,
  RESET_PASSWORD,
  VALIDATE_UUID_LINK,
  CONTRACTOR_LIST,
  CONTRACTOR,
  TIMESHEET_LIST,
  TIMESHEET,
  LHB_RECORDS,
  DESIGNATION_LIST,
  DASHBOARD,
  PLANT_HEAD_DASHBOARD,
  SUBACTIVITY_UNIQUE_LIST,
  SUPERVISOR_DASHBOARD,
  PLANNING_DASHBOARD,
  PENDING_SUBMISSIONS,
  EMPLOYEE_PRODUCTIVITY,
  INDUSTRIAL_REPORT,
  PLANNING_REPORT,
  USERS_SYSTEM_REPORT,
  IE_DASHBOARD,
  ADMIN_DASHBOARD,
  MASTER_CHANGE_LOG_REPORT,
  EXPORT_PROJECT_CSV,
  EXPORT_TECHNICIAN_CSV,
  EXPORT_SUBACTIVITY_CSV,
  EXPORT_MICROACTIVITY_CSV,
  EXPORT_PENDING_SUBMISSIONS_CSV,
  EXPORT_EMPLOYEE_PRODUCTIVITY_CSV,
  EXPORT_USERS_SYSTEM_REPORT_CSV,
  EXPORT_MASTER_CHANGE_LOG_REPORT_CSV,
  EXPORT_INDUSTRIAL_REPORT_CSV,
  EXPORT_PLANNING_REPORT_CSV,
  EMPLOYEE_EFFICIENCY_REPORT,
  EXPORT_EMPLOYEE_EFFICIENCY_REPORT_CSV,
} from "./apiConstants";
import { v4 as uuidv4 } from "uuid";

const API = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// API.interceptors.request.use((req) => {
//   if (localStorage.getItem("p")) {
//     req.headers.token = JSON.parse(localStorage.getItem("p")).token;
//   }
//   return req;
// });

API.interceptors.request.use((req) => {
  req.headers["key"] = uuidv4();
  req.headers["token"] = uuidv4();
  req.headers["ltk"] = uuidv4();

  return req;
});

// Login API
export const login_api = (loginData) => API.post(`${LOGIN}`, loginData);

// Logout API
export const logout_api = () => API.post(`${LOGOUT}`);

//users
export const user_list = (pageNum, filtersJSON) =>
  API.get(USER_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_user = (bodyData) => API.post(`${USER}`, bodyData);
export const edit_user = (id, bodyData) => API.patch(`${USER}${id}`, bodyData);
export const get_user_by_ID = (id) => API.get(`${USER}${id}`);
export const delete_user_by_ID = (id) => API.delete(`${USER}${id}`);

//departments
export const department_list = (pageNum, filtersJSON) =>
  API.get(DEPARTMENT_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_department = (bodyData) => API.post(`${DEPARTMENT}`, bodyData);
export const edit_department = (id, bodyData) =>
  API.patch(`${DEPARTMENT}${id}`, bodyData);
export const get_department_by_ID = (id) => API.get(`${DEPARTMENT}${id}`);
export const delete_department_by_ID = (id) => API.delete(`${DEPARTMENT}${id}`);

//unit listing
export const get_unit_listing = (pageNum, filtersJSON) =>
  API.get(UNIT_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
//add unit
export const add_unit = (bodyData) => API.post(UNIT, bodyData);
//get update unit
export const edit_unit = (id, bodyData) => API.patch(`${UNIT}${id}`, bodyData);
export const get_unit_by_ID = (id) => API.get(`${UNIT}${id}`);
//delete the unit by id
export const delete_unit_by_Id = (id) => API.delete(`${UNIT}${id}`);

//customers
export const customer_list = (pageNum, filtersJSON) =>
  API.get(CUSTOMER_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_customer = (bodyData) => API.post(`${CUSTOMER}`, bodyData);
export const edit_customer = (id, bodyData) =>
  API.patch(`${CUSTOMER}${id}`, bodyData);
export const get_customer_by_ID = (id) => API.get(`${CUSTOMER}${id}`);
export const delete_customer_by_ID = (id) => API.delete(`${CUSTOMER}${id}`);

//duty type
export const duty_type_list = (pageNum, filtersJSON) =>
  API.get(DUTY_TYPE_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_duty_type = (bodyData) => API.post(`${DUTY_TYPE}`, bodyData);
export const edit_duty_type = (id, bodyData) =>
  API.patch(`${DUTY_TYPE}${id}`, bodyData);
export const get_duty_type_by_ID = (id) => API.get(`${DUTY_TYPE}${id}`);
export const delete_duty_type_by_ID = (id) => API.delete(`${DUTY_TYPE}${id}`);

//role listing
export const get_role_listing = (pageNum, filtersJSON) =>
  API.get(ROLE_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
//add role
export const add_role = (bodyData) => API.post(ROLE, bodyData);
//update role
export const edit_role = (id, bodyData) => API.patch(`${ROLE}${id}`, bodyData);
export const get_role_detail_by_ID = (id) => API.get(`${ROLE}${id}`);
//delete the role
export const delete_role_by_ID = (id) => API.delete(`${ROLE}${id}`);

//shift
export const get_shift_list = (pageNum, filtersJSON) =>
  API.get(SHIFT_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_shift = (bodyData) => API.post(`${SHIFT}`, bodyData);
export const edit_shift = (id, bodyData) =>
  API.patch(`${SHIFT}${id}`, bodyData);
export const get_shift_by_ID = (id) => API.get(`${SHIFT}${id}`);
export const delete_shift_by_ID = (id) => API.delete(`${SHIFT}${id}`);

//station
export const station_list = (pageNum, filtersJSON) =>
  API.get(STATION_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_station = (bodyData) => API.post(`${STATION}`, bodyData);
export const edit_station = (id, bodyData) =>
  API.patch(`${STATION}${id}`, bodyData);
export const get_station_by_ID = (id) => API.get(`${STATION}${id}`);
export const delete_station_by_ID = (id) => API.delete(`${STATION}${id}`);

//sub activity
export const subActivity_list = (pageNum, filtersJSON) =>
  API.get(SUBACTIVITY_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const subActivity_unique_list = (pageNum, filtersJSON) =>
  API.get(SUBACTIVITY_UNIQUE_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_subActivity = (bodyData) =>
  API.post(`${SUBACTIVITY}`, bodyData);
export const edit_subActivity = (id, bodyData) =>
  API.patch(`${SUBACTIVITY}${id}`, bodyData);
export const get_subActivity_by_ID = (id) => API.get(`${SUBACTIVITY}${id}`);
export const delete_subActivity_by_ID = (id) =>
  API.delete(`${SUBACTIVITY}${id}`);
export const import_subactivity = (fileData) =>
  API.post(`${SUBACTIVITY}import`, fileData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// get export csv sub activity
export const subActivity_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_SUBACTIVITY_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

//micro activity
export const microActivity_list = (pageNum, filtersJSON) =>
  API.get(MICROACTIVITY_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const microActivity_unique_list = (pageNum, filtersJSON) =>
  API.get(MICROACTIVITY_UNIQUE_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_microActivity = (bodyData) =>
  API.post(`${MICROACTIVITY}`, bodyData);
export const edit_microActivity = (id, bodyData) =>
  API.patch(`${MICROACTIVITY}${id}`, bodyData);
export const get_microActivity_by_ID = (id) => API.get(`${MICROACTIVITY}${id}`);
export const delete_microActivity_by_ID = (id) =>
  API.delete(`${MICROACTIVITY}${id}`);
export const import_microActivity = (fileData) =>
  API.post(`${MICROACTIVITY}import`, fileData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
// get export csv micro activity
export const microActivity_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_MICROACTIVITY_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

//product
export const product_list = (pageNum, filtersJSON) =>
  API.get(PRODUCT_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_product = (bodyData) => API.post(`${PRODUCT}`, bodyData);
export const edit_product = (id, bodyData) =>
  API.patch(`${PRODUCT}${id}`, bodyData);
export const get_product_by_ID = (id) => API.get(`${PRODUCT}${id}`);
export const delete_product_by_ID = (id) => API.delete(`${PRODUCT}${id}`);

//project
export const project_list = (pageNum, filtersJSON) =>
  API.get(PROJECT_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_project = (bodyData) => API.post(`${PROJECT}`, bodyData);
export const edit_project = (id, bodyData) =>
  API.patch(`${PROJECT}${id}`, bodyData);
export const get_project_by_ID = (id) => API.get(`${PROJECT}${id}`);
export const delete_project_by_ID = (id) => API.delete(`${PROJECT}${id}`);
export const import_project = (fileData) =>
  API.post(`${PROJECT}import`, fileData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// get export csv project
export const project_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_PROJECT_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

//remark
export const remark_list = (pageNum, filtersJSON) =>
  API.get(REMARK_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_remark = (bodyData) => API.post(`${REMARK}`, bodyData);
export const edit_remark = (id, bodyData) =>
  API.patch(`${REMARK}${id}`, bodyData);
export const get_remark_by_ID = (id) => API.get(`${REMARK}${id}`);
export const delete_remark_by_ID = (id) => API.delete(`${REMARK}${id}`);

//change password
export const change_password = (passwordData) =>
  API.patch(`${CHANGE_PASSWORD}`, passwordData);

//technician
export const technician_list = (pageNum, filtersJSON) =>
  API.get(TECHNICIAN_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_technician = (bodyData) => API.post(`${TECHNICIAN}`, bodyData);
export const edit_technician = (id, bodyData) =>
  API.patch(`${TECHNICIAN}${id}`, bodyData);
export const get_technician_by_ID = (id) => API.get(`${TECHNICIAN}${id}`);
export const delete_technician_by_ID = (id) => API.delete(`${TECHNICIAN}${id}`);
export const import_technician = (fileData) =>
  API.post(`${USER}import`, fileData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

// get export csv technician
export const technician_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_TECHNICIAN_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

//forget password
export const forgot_password = (emailData) => API.post(`${FORGET}`, emailData);

//reset password
export const reset_password = (emailData) =>
  API.post(`${RESET_PASSWORD}`, emailData);

//validate uuid link
export const validate_uuid = (uuid) => API.get(`${VALIDATE_UUID_LINK}${uuid}`);

//contractor
export const contractor_list = (pageNum, filtersJSON) =>
  API.get(CONTRACTOR_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const add_contractor = (bodyData) => API.post(`${CONTRACTOR}`, bodyData);
export const edit_contractor = (id, bodyData) =>
  API.patch(`${CONTRACTOR}${id}`, bodyData);
export const get_contractor_by_ID = (id) => API.get(`${CONTRACTOR}${id}`);
export const delete_contractor_by_ID = (id) => API.delete(`${CONTRACTOR}${id}`);

//timesheet
export const timesheet_list = (pageNum, filtersJSON) =>
  API.get(TIMESHEET_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//designation
export const designation_list = (pageNum, filtersJSON) =>
  API.get(DESIGNATION_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

export const get_timesheet_by_ID = (id) => API.get(`${TIMESHEET}${id}`);

export const update_timesheet_status = (id, bodyData) =>
  API.patch(`${TIMESHEET}${id}`, bodyData);

export const delete_lhb_record_by_ID = (id) =>
  API.delete(`${LHB_RECORDS}${id}`);

export const edit_lhbRecords_by_Id = (id, bodyData) =>
  API.patch(`${LHB_RECORDS}${id}`, bodyData);

export const add_lhb_record = (bodyData) =>
  API.post(`${LHB_RECORDS}`, bodyData);

export const dashboard_data = (bodyData) => API.post(`${DASHBOARD}`, bodyData);

export const plant_head_dashboard_data = (bodyData) =>
  API.post(`${PLANT_HEAD_DASHBOARD}`, bodyData);

export const supervisor_dashboard_data = (bodyData) =>
  API.post(`${SUPERVISOR_DASHBOARD}`, bodyData);

export const planning_dashboard_data = (bodyData) =>
  API.post(`${PLANNING_DASHBOARD}`, bodyData);

export const ie_dashboard_data = (bodyData) =>
  API.post(`${IE_DASHBOARD}`, bodyData);

export const admin_dashboard_data = (bodyData) =>
  API.post(`${ADMIN_DASHBOARD}`, bodyData);

//reports
export const pending_submissions_report = (pageNum, filtersJSON) =>
  API.get(PENDING_SUBMISSIONS, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
// get export csv pending_submissions_report & export with filters
export const pending_submissions_report_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_PENDING_SUBMISSIONS_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

export const employee_productivity_report = (pageNum, filtersJSON) =>
  API.get(EMPLOYEE_PRODUCTIVITY, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
// get export csv employee_productivity_report & export with filters
export const employee_productivity_report_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_EMPLOYEE_PRODUCTIVITY_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

export const industrial_report = (pageNum, filtersJSON) =>
  API.get(INDUSTRIAL_REPORT, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
// get export csv industrial_report & export with filters
export const industrial_report_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_INDUSTRIAL_REPORT_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

export const planning_report = (pageNum, filtersJSON) =>
  API.get(PLANNING_REPORT, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
// get export csv planning_report & export with filters
export const planning_report_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_PLANNING_REPORT_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

export const users_system_report = (pageNum, filtersJSON) =>
  API.get(USERS_SYSTEM_REPORT, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
// get export csv users_system_report & export with filters
export const users_system_report_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_USERS_SYSTEM_REPORT_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

export const master_change_log_report = (pageNum, filtersJSON) =>
  API.get(MASTER_CHANGE_LOG_REPORT, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
// get export csv master_change_log_report & export with filters
export const master_change_log_report_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_MASTER_CHANGE_LOG_REPORT_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};

export const employee_efficiency_report = (pageNum, filtersJSON) =>
  API.get(EMPLOYEE_EFFICIENCY_REPORT, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
// get export csv employee_efficiency_report & export with filters
export const employee_efficiency_report_csv_export = (filtersJSON = "[]") => {
  return API.get(EXPORT_EMPLOYEE_EFFICIENCY_REPORT_CSV, {
    params: {
      filtersJSON,
    },
    responseType: "blob",
    headers: {
      token: localStorage.getItem("token"),
    },
  });
};
